export default __webpack_public_path__ + "static/all_meth_lab_locations-74af0fcd12f175637931074906483a64.png";